import React from 'react';
import AllRoute from '../router/Router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../sass/style.scss';
import useLanguageFromIp from '../../hooks/useLanguageFromIp';

const App = () => {
  useLanguageFromIp();
  return (
    <div className="App" id="scrool">
      <AllRoute />
      <ToastContainer />
    </div>
  );
};

export default App;
